export const blockIconsAudioandvideoPlaylistAdd = (
	<span className='material-symbols-outlined'>playlist_add</span>
);
